const DEV_CORE_API_URL = "http://localhost:8081";

function normalizeBaseUrl(url) {
	return String(url || "").trim().replace(/\/$/, "");
}

function getApiBaseUrl() {
	const configured = normalizeBaseUrl(process.env.REACT_APP_API_URL || "");

	if (!configured) {
		return DEV_CORE_API_URL;
	}

	if (/^:\d+$/.test(configured)) {
		return `http://localhost${configured}`;
	}

	if (/^localhost:\d+$/i.test(configured)) {
		return `http://${configured}`;
	}

	return configured;
}

const API_BASE_URL = getApiBaseUrl();

export async function submitChallengeAnswer(answer) {
	const response = await fetch(`${API_BASE_URL}/api/auth/challenge`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		credentials: "include",
		body: JSON.stringify({ answer }),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Could not verify answer");
	}

	return payload;
}

export async function selectProfile(userId) {
	const response = await fetch(`${API_BASE_URL}/api/auth/select-profile`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		credentials: "include",
		body: JSON.stringify({ userId }),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Could not select profile");
	}

	return payload;
}

export async function getSession() {
	const response = await fetch(`${API_BASE_URL}/api/auth/session`, {
		method: "GET",
		credentials: "include",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Not authenticated");
	}

	return payload;
}

export async function logout() {
	const response = await fetch(`${API_BASE_URL}/api/auth/logout`, {
		method: "POST",
		credentials: "include",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to logout");
	}

	return payload;
}

export async function getSecurityQuestion() {
  const response = await fetch(`${API_BASE_URL}/api/auth/security-question`, {
    method: "GET",
    credentials: "include",
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok) {
    throw new Error(payload.error || "Could not load security question");
  }

  return payload;
}

export async function setSecurityQuestion(userId, question, answer) {
  const response = await fetch(`${API_BASE_URL}/api/auth/security-question/set`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ userId, question, answer }),
  });
  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }
  if (!response.ok) {
    throw new Error(payload.error || "Could not save security question");
  }
  return payload;
}

export async function verifySecurityQuestion(userId, answer) {
  const response = await fetch(`${API_BASE_URL}/api/auth/security-question/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ userId, answer }),
  });
  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }
  if (!response.ok) {
    throw new Error(payload.error || "Incorrect answer");
  }
  return payload;
}